export default {
  path: '/anomaly-results/:id',
  component: () =>
    import(
      '@/components/pages/AnomalyResults/AnomalyResult.vue'
    )
}
